// The rows a history card lists (2026-10-10): only the results or causes that
// happened in the period, in their fixed order, plus this game's own row even
// if its count were 0.

/** The views whose count is above 0, or that are this game's, in the order given. */
export function shownRows<V>(views: readonly V[], count: (view: V) => number, mine: (view: V) => boolean): V[] {
  return views.filter((v) => count(v) > 0 || mine(v));
}
